import { Wallet } from 'lucide-react';

interface BillingButtonProps {
  onClick: () => void;
  balance?: number | null;
  loading?: boolean;
}

/**
 * Billing button for app header
 * Shows wallet icon and optionally the current balance
 */
export function BillingButton({ onClick, balance, loading }: BillingButtonProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
    >
      <Wallet className="w-5 h-5" />
      {loading ? (
        <span className="text-sm">Loading...</span>
      ) : balance !== null && balance !== undefined ? (
        <span className="text-sm">Billing/Wallet {formatCurrency(balance)}</span>
      ) : (
        <span className="text-sm">Billing/Wallet</span>
      )}
    </button>
  );
}
